<template>

  <!-- Video Player -->
  <q-responsive
    :ratio="ratio"
    class="video-player"
    @click.capture="$emit('click')">

    <!-- Has Source -->
    <template
      v-if="source">

      <!-- Is File -->
      <clappr-player
        v-if="isFile"
        :poster="poster"
        :source="source"
        :autoplay="autoplay"
        class="video-player__player"/>

      <!-- I-Frame -->
      <iframe
        v-else
        :src="source"
        frameborder="0"
        allowfullscreen
        allow="autoplay;fullscreen;"
        class="video-player__player"/>

    </template>

    <!-- Placeholder -->
    <img
      v-else
      class="video-player__player"
      src="/images/bg/bg-thumb.jpg"/>

    <!--
    <video
      loop
      muted
      v-else
      autoplay
      class="video-player__player">

      <source
        type="video/mp4"
        src="/images/bg/intro-digital-show.mp4">

    </video>
    -->

  </q-responsive>

</template>

<script>

  import ClapprPlayer from '@src/components/player/clappr-player';

  const exts = [
    'm3u8',
    'webm',
    'mp4',
  ];

  export default {
    name: 'video-player',
    props: {
      source: {
        type: String,
        default: '',
      },
      poster: {
        type: String,
        default: undefined,
      },
      ratio: {
        type: Number,
        default: 16 / 9,
      },
      autoplay: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ClapprPlayer,
    },
    computed: {
      isFile() {

        const ext = this.source
          .split('.')
          .pop();

        return exts.indexOf(
          ext,
        ) !== -1;
      },
    },
  };

</script>

<style lang="scss">

  .video-player {
    position: relative;
    background-color: black;

    &__player {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
      position: absolute;

      &:not(iframe) {
        object-fit: cover;
      }
    }
  }

</style>
